import { Dispatch, FC, SetStateAction, useContext, SyntheticEvent } from 'react'
import { Box, Tabs, Tab } from '@mui/material'
import GeneralSection from '../GeneralSection'
import LocationSection from '../LocationSection'
import FrequencySection from '../FrequencySection'
import EquipmentSection from '../Equipment'
import { RequestContext } from '../../../../contexts/request.context'
import { TabPanel } from '../../../shared/TabPanel'
import { RequestsFormTabs } from '../../../../utils/constants'

import styles from './styles.module.scss'

interface IProps {
  value: number
  setValue: Dispatch<SetStateAction<number>>
  isLightMode: boolean
  onClose?: () => void
}

const Sections: FC<IProps> = ({ value, setValue, onClose, isLightMode }) => {
  const { selectedRequest } = useContext(RequestContext)

  const handleTabChange = (_: SyntheticEvent, value: number) => {
    setValue(value)
  }

  return (
    <Box className={`${styles.sections} sub-container`}>
      {selectedRequest && (
        <>
          <Box className={styles.tabsOuterContainer}>
            <Box className={styles.leftContainer}>
              <Tabs
                value={value}
                onChange={handleTabChange}
                className={styles.tabsContainer}
              >
                {RequestsFormTabs?.map((tab) => (
                  <Tab key={tab.label} label={tab.label} />
                ))}
              </Tabs>
            </Box>
          </Box>
          <Box className={styles.tabBodiesContainer}>
            <TabPanel value={value} index={0}>
              <Box sx={{ overflowY: 'hidden', overflowX: '' }}>
                <GeneralSection
                  setValue={setValue}
                  selectedRequest={selectedRequest}
                />
              </Box>
            </TabPanel>
            <TabPanel key={1} value={value} index={1}>
              <LocationSection isLightMode={isLightMode} setValue={setValue} />
            </TabPanel>
            <TabPanel key={2} value={value} index={2}>
              <FrequencySection isLightMode={isLightMode} setValue={setValue} />
            </TabPanel>
            <TabPanel key={3} value={value} index={3}>
              <EquipmentSection
                onClose={onClose}
                isLightMode={isLightMode}
                setValue={setValue}
              />
            </TabPanel>
          </Box>
        </>
      )}
    </Box>
  )
}

export default Sections
